import React, { useState } from "react";
import { empleadosService } from "../services/api";
import { Button, Card } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import { toast } from "react-toastify";

const Employees = () => {
  const [loading, setLoading] = useState(false);

  const handleImportEmployees = async () => {
    try {
      setLoading(true);
      const response = await empleadosService.importEmployees();

      if (response.data.success) {
        toast.success(`Empleados importados correctamente. ${response.data.count} registros procesados.`);
      } else {
        toast.error(response.data.message || "Error al importar empleados");
      }
    } catch (error) {
      console.error('Error importando empleados:', error);
      toast.error(
        error.response?.data?.message ||
        "Error al importar empleados. Verifique la conexión con la base de datos."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <Card className="text-center" style={{ maxWidth: "400px" }}>
        <Card.Body>
          <h4 className="mb-4">Import Employees</h4>
          <Button
            variant="primary"
            onClick={handleImportEmployees}
            disabled={loading}
            className="d-flex align-items-center gap-2 mx-auto"
          >
            <FaUpload />
            {loading ? "Importando..." : "Import"}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Employees; 